import type { FC } from "react";
import type { IconBaseProps, IconType } from "react-icons";
import { colours } from "../../styles/colours.constants";
import * as CSS from "./icon.styles";

export type IconProps = IconBaseProps & {
	icon: IconType;
	as?: "button";
	onClick?: () => void;
	disabled?: boolean;
};

const Icon: FC<IconProps> = ({
	icon,
	as,
	onClick,
	disabled = false,
	...props
}) => {
	const Component = icon as FC<IconBaseProps>;

	if (as === "button") {
		return (
			<CSS.Button onClick={onClick} disabled={disabled}>
				<Component size={32} color={colours.black} {...props} />
			</CSS.Button>
		);
	}

	return <Component size={32} {...props} />;
};

export default Icon;
